import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Sunrise, RefreshCw, Sparkles } from "lucide-react";
import { GlassCard } from "@/components/ui/GlassCard";
import { NxButton } from "@/components/ui/NxButton";
import { apiGet } from "@/lib/api";
import pt from "@/lib/i18n";

export const MorningBriefing = () => {
    const [briefing, setBriefing] = useState(null);
    const [loading, setLoading] = useState(true);
    const [displayText, setDisplayText] = useState("");

    const load = async (regenerate = false) => {
        setLoading(true);
        if (regenerate) setDisplayText("");
        try {
            const r = await apiGet("/nexustel/morning-briefing");
            setBriefing(r);
            // Typewriter only on regenerate; otherwise show full immediately
            if (regenerate) {
                const text = r.briefing || "";
                let i = 0;
                const id = setInterval(() => {
                    i += 5;
                    setDisplayText(text.slice(0, i));
                    if (i >= text.length) clearInterval(id);
                }, 18);
            } else {
                setDisplayText(r.briefing);
            }
        } catch (e) { setBriefing(null); }
        setLoading(false);
    };

    useEffect(() => { load(false); }, []);

    return (
        <motion.div initial={{ opacity: 0, y: 8 }} animate={{ opacity: 1, y: 0 }}>
            <GlassCard
                padding="p-6"
                data-testid="morning-briefing-card"
                style={{
                    borderColor: "var(--copper)",
                    borderWidth: 1.5,
                    background: "linear-gradient(135deg, rgba(255,247,237,0.98), rgba(248,235,221,0.85))",
                }}
            >
                <div className="flex items-center justify-between mb-3">
                    <div className="flex items-center gap-2">
                        <Sunrise size={18} className="text-[color:var(--copper)]" />
                        <span className="font-body text-xs uppercase tracking-[0.2em] text-[color:var(--copper-dark)] font-semibold">
                            {pt.nexustel.morningBriefing}
                        </span>
                    </div>
                    <button
                        onClick={() => load(true)}
                        disabled={loading}
                        className="text-[color:var(--copper-dark)] hover:text-[color:var(--copper)] flex items-center gap-1 font-mono text-xs"
                        data-testid="btn-refresh-briefing"
                    >
                        <RefreshCw size={11} className={loading ? "animate-spin" : ""} />
                        {pt.nexustel.refreshBriefing}
                    </button>
                </div>
                {loading && !displayText ? (
                    <motion.p
                        className="font-body text-sm italic text-[color:var(--copper-dark)] flex items-center gap-1.5"
                        animate={{ opacity: [0.5, 1, 0.5] }}
                        transition={{ duration: 1.5, repeat: Infinity }}
                    >
                        <Sparkles size={12} /> {pt.nexustel.briefingLoading || "A preparar o seu briefing matinal…"}
                    </motion.p>
                ) : (
                    <p className="font-body text-[15px] leading-[1.75] text-[color:var(--slate-deep)]" data-testid="briefing-text">
                        {displayText}
                    </p>
                )}
            </GlassCard>
        </motion.div>
    );
};

export default MorningBriefing;
